export function removeNoNumbersCharactersFromChangeEvent(event) {
  event.target.value = event.target.value.replace(/\D/g, '');
  return event;
}
